import React, { memo } from 'react';
import PropTypes from 'prop-types';
import MuiButton from '@mui/material/Button';
import { makeStyles } from 'src/makeStyles';
import { colors } from '../../constants/styleConstants';
import { useTranslation } from '../../src/i18n';
import { TP } from '../../constants/consts';

const useStyles = makeStyles()({
  button: {
    padding: 4,
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '14px',
    borderRadius: 4,
    textTransform: 'uppercase',
    minWidth: 0,
    color: colors.blue3,
    '&:hover': {
      backgroundColor: colors.blue3Opacity20,
    },
    '&:active': {
      color: colors.blue6,
      backgroundColor: colors.blue3Opacity20,
    },
  },
  disabled: {
    '&.MuiButton-root.Mui-disabled': {
      color: colors.blue3Opacity50,
    },
  },
});

const EditButton = ({ className, disabled, label, ...rest }) => {
  const { t } = useTranslation();
  const { classes, cx } = useStyles();

  return (
    <MuiButton
      className={cx(classes.button, className)}
      classes={{ disabled: classes.disabled }}
      variant="text"
      disabled={disabled}
      {...rest}
    >
      {label || t(`${TP}.FN_EDIT`)}
    </MuiButton>
  );
};

EditButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
};

EditButton.defaultProps = {
  disabled: false,
};

export default memo(EditButton);
